import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";

// Set document title immediately
document.title = "CTOBRA";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<App />);

// Ensure title stays set even after any external script attempts to change it
const observer = new MutationObserver(() => {
  if (document.title !== "CTOBRA") {
    document.title = "CTOBRA";
  }
});

observer?.observe(document.querySelector('title'), {
  childList: true,
  characterData: true,
  subtree: true
});